import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";
export const useSuperAddStore = defineStore("superAdd", {
  state: () => ({
    // Step Control
    step: 0,

    // Step 0 - Platform Selection
    selectedAccounts: {}, // { facebook: 'page_id', ... }
    selectedObjective: "",
    selectedAccounts2:
      JSON.parse(localStorage.getItem("superselected_accounts")) || {},
    addacounts:
      JSON.parse(localStorage.getItem("selected_identity_accounts")) || {},
    // Step 1 - Campaign Setup
    campaignName: "",
    campaignObjective: "awareness",
    startDate: null,
    endDate: null,
    status: true,
    disableMeta: true,
    activeBid: false,
    bidamount: "",
    tiktokcreativeu: "",
    snapchatcreativeu: "",
    facebookcreativeu: "",
    tiktokcreativeurl: "",
    resultDialog: false,
    facebookcrerror: false,
    successPlatforms: {},
    failedPlatforms: {},
    adSetName: "",
    performanceGoal: null,
    chargeType: "Impression", // default used in template
    allowVideoSharing: false,
    Adsetstatus: true,
    ageFrom: "18",
    ageTo: "55",
    selectedGender: "all",
    brandSafety: "moderate",
    deliveryType: "Standard",
    selectedCityId: [],
    language: [],
    faildmsg: "",
    succmsg: "",
    failupload: "",
    succupload: "",
    selectedInterests: [],
    interestsMap: [],

    platforms: [
      {
        name: "Meta",
        icon: new URL("@/assets/images/icons/meta.png", import.meta.url).href,
        budget: "",
        budgetType: "daily",
        currency: "USD",
      },
      {
        name: "Snapchat",
        icon: new URL("@/assets/images/icons/snap.png", import.meta.url).href,
        budget: "",
        budgetType: "daily",
        currency: "USD",
      },
      {
        name: "TikTok",
        icon: new URL("@/assets/images/icons/tiktok.png", import.meta.url).href,
        budget: "",
        budgetType: "daily",
        currency: "USD",
      },
    ],
    campaignData: {},

    // Step 2 - Ad Set
    adSetData: {},
    // step 3
    adCreativeData: {
      // 🎯 Ad Creative
      videoFile: null,
      headline: "",
      caption: "",

      // 🧾 Ad Details
      adName: "",
      identity: null, // "Meta Page", "Snapchat Account", "TikTok Account"
      status: true, // true = Active, false = Paused
      format: "Single Video",

      // 🔗 Destination Section
      showDestination: false,
      attachmentType: "Web view", // or "App link"
      websiteUrl: null,
      deepLink: null,
      cta: null, // or "Learn more", "Shop now", etc.
      music_id: null,
      isImage: false,
    },
    // Final Preview (optional)
    previewData: null,
    selectedForms: [],
    websiteUrlLeeds: "",
    ad_call_to_action_type: "APPLY_NOW",
  }),

  getters: {
    fullPayload: (state) => {
      return {
        objective: state.selectedObjective,
        selected_accounts: state.selectedAccounts,
        campaign: state.campaignData,
        ad_set: state.adSetData,
        creative: state.adCreativeData,
      };
    },
  },

  actions: {
    appendInterestsToFormData(formData) {
      const platformIndices = {
        facebook: 0,
        snapchat: 0,
        tiktok: 0,
      };

      (this.interestsMap || []).forEach((interest) => {
        const index = platformIndices[interest.platform] ?? 0;

        switch (interest.platform) {
          case "facebook":
            formData.append(
              `adset_facebook_interests[${index}][id]`,
              interest.fake_id
            );
            formData.append(
              `adset_facebook_interests[${index}][name]`,
              interest.label
            );
            break;

          case "snapchat":
            formData.append(`adset_snapchat_interests[${index}]`, interest.fake_id);
            break;

          case "tiktok":
            formData.append(`adset_tiktok_interests[${index}]`, interest.fake_id);
            break;

          default:
            console.warn("❌ Unknown interest platform:", interest.platform);
            break;
        }

        platformIndices[interest.platform] = index + 1;
      });
    },
    updateField(key, value) {
      this[key] = value;
    },

    updatePlatformBudget(index, budget) {
      this.platforms[index].budget = budget;
    },

    setCampaignData(data) {
      this.campaignData = data;
      console.log("✅ Campaign Data Saved:", data);
    },

    setAdSetData(data) {
      this.adSetData = {
        ...this.adSetData,
        ...data,
      };
    },

    setCreativeData(data) {
      this.adCreativeData = data;
    },

    setSelectedAccounts(data) {
      this.selectedAccounts = data;
    },

    setSelectedObjective(value) {
      this.selectedObjective = value;
    },

    setPreviewData(data) {
      this.previewData = data;
    },

    updateStep(val) {
      this.step = val;
    },

    resetAll() {
      this.$reset();
    },
    testerfun() {
      if (this.adCreativeData.showDestination) {
        console.log("true hg jjh", this.adCreativeData.showDestination);
      } else {
        console.log("false asdasd asdsads");
      }
    },
    async uploadMedia() {
      const formData = new FormData();

      if (!this.adCreativeData.videoFile) {
        console.warn("No media file selected");
        return;
      }

      formData.append("media", this.adCreativeData.videoFile);
      const selectedNames =
        JSON.parse(localStorage.getItem("super_selected_platforms")) || [];
      const platformAlias = {
        meta: "facebook",
        snapchat: "snapchat",
        tiktok: "tiktok",
      };

      selectedNames?.forEach((p, i) => {
        const raw = p.name.toLowerCase();
        const platform = platformAlias[raw] || raw;
        formData.append(`platforms[${i}]`, platform);
      });

      const storedAccounts = JSON.parse(
        localStorage.getItem("superselected_accounts") || "{}"
      );

      formData.append("facebook_account_id", storedAccounts.facebook?.id || "");
      formData.append("snapchat_account_id", storedAccounts.snapchat?.id || "");
      formData.append("tiktok_account_id", storedAccounts.tiktok?.id || "");

      // الإعلان
      formData.append("ad_primary_text", this.adCreativeData.headline || "");
      formData.append("ad_caption", this.adCreativeData.caption || "");
      formData.append("ad_name", this.adCreativeData.adName || "");

      if (this.adCreativeData.showDestination) {
        formData.append("deep_link_uri", this.adCreativeData.deepLink);
        formData.append("ad_attachments_type", "WEB_VIEW");
      } else {
        if (this.campaignObjective === "leads") {
          formData.append("ad_attachments_type", "LEAD_GENERATION");
        } else {
          formData.append("ad_attachments_type", "DEFAULT");
        }
      }

      if (this.campaignObjective === "leads") {
        formData.append("campaign_objective", "OUTCOME_LEADS");
        formData.append("ad_call_to_action_type", this.ad_call_to_action_type);

        console.log("🧪 selectedForms", this.selectedForms);
        // بضيف كل فورم تم اختياره للمنصة الخاصة بيه
        this.selectedForms.forEach((form) => {
          formData.append(`${form.platform}_lead_generation_form_id`, form.id);
        });
      } else {
        formData.append(
          "ad_call_to_action_type",
          (this.adCreativeData.cta || "").toUpperCase().replace(/\s/g, "_")
        );
      }

      if (this.campaignObjective === "leads") {
        formData.append("ad_link_url", this.websiteUrlLeeds || "");
      } else {
        formData.append("ad_link_url", this.adCreativeData.websiteUrl || "");
      }

      formData.append(
        "ad_status",
        this.adCreativeData.status ? "ACTIVE" : "PAUSED"
      );

      // الحسابات المرتبطة
      const identities = JSON.parse(
        localStorage.getItem("selected_identity_accounts") || "{}"
      );

      if (identities.facebook)
        formData.append("ad_facebook_page_id", identities.facebook.id);
      if (identities.instagram)
        formData.append("ad_instagram_user_id", identities.instagram.id);
      if (identities.snapchat)
        formData.append("snapchat_profile_id", identities.snapchat.id);
      if (identities.tiktok)
        formData.append("tiktok_profile_id", identities.tiktok.id);
      console.log(this.selectedAccounts, "formData");
      try {
        const response = await apiClient.post(
          "/super-ad/upload/media",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.tiktokcreativeu = response.data?.data?.success?.tiktok?.id || "";
        this.tiktokcreativeurl =
          response.data?.data?.success?.tiktok?.url || "";
        this.snapchatcreativeu =
          response.data?.data?.success?.snapchat?.id || "";
        this.facebookcreativeu =
          response.data?.data?.success?.facebook?.id || "";
        const success = response.data?.data?.success || {};
        const failed = response.data?.data?.failed || [];
        this.failupload = success || "";
        this.succupload = failed || "";
        return response.data;
      } catch (error) {
        console.error("❌ Upload failed:", error.response?.data || error);
        throw error;
      }
    },
    async createSuperAd() {
      const formData = new FormData();

      const platformNameMap = {
        Meta: "facebook",
        Snapchat: "snapchat",
        Tiktok: "tiktok",
      };

      const failedPlatforms = Array.isArray(this.faildmsg)
        ? this.faildmsg.map((f) => f.platform?.toLowerCase())
        : typeof this.faildmsg === "object"
        ? Object.keys(this.faildmsg).map((p) => p.toLowerCase())
        : [];

      const creativeMap = {
        facebook: this.facebookcreativeu,
        snapchat: this.snapchatcreativeu,
        tiktok: this.tiktokcreativeu,
      };
      let platformIndex = 0;

      this.campaignData.platforms.forEach((p) => {
        const key = platformNameMap[p.name];

        const creativeId = creativeMap[key];

        const isMediaFailed = failedPlatforms.includes(key);
        const isCreativeMissing = !creativeId;

        if (key && !isMediaFailed && creativeId) {
          formData.append(`platforms[${platformIndex}]`, key);
          platformIndex++;
        } else {
          console.log(
            `⛔️ Skipping ${key} - Failed Media: ${isMediaFailed}, Missing Creative: ${isCreativeMissing}`
          );
        }
      });

      const providerIdMap = {
        facebook: "facebook_account_id",
        snapchat: "snapchat_account_id",
        tiktok: "tiktok_account_id",
      };

      const storedAccounts = JSON.parse(
        localStorage.getItem("superselected_accounts") || "{}"
      );

      for (const [provider, field] of Object.entries(providerIdMap)) {
        if (storedAccounts[provider]?.id) {
          formData.append(field, storedAccounts[provider].id);
        }
      }

      formData.append("campaign_name", this.campaignData.campaignName);
      const start = new Date(this.campaignData.startDate);
      const end = new Date(this.campaignData.endDate);

      if (end - start < 86400000) {
        end.setTime(start.getTime() + 86400000 + 1000);
      }

      const formatDateTime = (date) => {
        return (
          date.getFullYear() +
          "-" +
          String(date.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(date.getDate()).padStart(2, "0") +
          " " +
          String(date.getHours()).padStart(2, "0") +
          ":" +
          String(date.getMinutes()).padStart(2, "0") +
          ":" +
          String(date.getSeconds()).padStart(2, "0")
        );
      };

      if (this.adCreativeData.isImage && this.adCreativeData.music_id) {
        formData.append("tiktok_music_id", this.adCreativeData.music_id);
      }
      formData.append("campaign_start_time", formatDateTime(start));
      formData.append("campaign_stop_time", formatDateTime(end));
      formData.append("campaign_status", this.status ? "ACTIVE" : "PAUSED");
      if (this.campaignObjective === "leads") {
        formData.append("campaign_objective", "OUTCOME_LEADS");
        this.selectedForms.forEach((form) => {
          formData.append(`${form.platform}_lead_generation_form_id`, form.id);
        });
      }
      if (this.campaignObjective === "video_views") {
        formData.append("campaign_objective", "OUTCOME_ENGAGEMENT");
      }
      if (this.campaignObjective === "awareness") {
        formData.append("campaign_objective", "OUTCOME_AWARENESS");
      }
      formData.append("adset_name", this.adSetData.adSetName);

      if (this.campaignObjective === "leads") {
        formData.append("adset_optimization_goal", "leads");
        formData.append("ad_call_to_action_type", this.ad_call_to_action_type);
        formData.append("ad_link_url", this.websiteUrlLeeds || "");
      }
        
      if (this.campaignObjective === "video_views") {
        formData.append(
          "adset_optimization_goal",
          `${this.adSetData.performanceGoal?.id.replace("s", "")}_seconds`
        );
      }
      if (this.campaignObjective === "awareness") {
        formData.append(
          "adset_optimization_goal",
          this.adSetData.performanceGoal?.id
        );
      }

      const platformKeyMap = {
        snapchat: "snap",
        tiktok: "tiktok",
        meta: "facebook",
      };

      this.campaignData.platforms.forEach((platform) => {
        const rawName = platform.name?.toLowerCase();
        const name = platformKeyMap[rawName];
        const budgetType = platform.budgetType?.toLowerCase();
        const amount = platform.amount;

        if (name && budgetType && amount) {
          const key = `adset_${name}_${budgetType}_budget`;
          formData.append(key, amount);
        }
      });

      formData.append(
        "adset_status",
        this.adSetData.status ? "ACTIVE" : "PAUSED"
      );

      if (this.activeBid) {
        formData.append(
          "adset_pacing",
          this.adSetData.deliveryType.toLowerCase()
        );
        formData.append("adset_bid_amount", this.bidamount);
      }

      if (this.campaignObjective === "leads") {
        formData.append(
          "adset_pacing",
          this.adSetData.deliveryType.toLowerCase()
        );
        formData.append("adset_bid_amount", this.bidamount);
      }
      formData.append("adset_brand_safety", this.adSetData.brandSafety);
      formData.append("adset_min_age", this.adSetData.ageFrom);
      formData.append("adset_max_age", this.adSetData.ageTo);
      formData.append(
        "adset_gender",
        this.adSetData.selectedGender.toUpperCase()
      );

      const langCodeMap = {
        Arabic: "ar",
        Chinese: "zh",
        Danish: "da",
        English: "en",
      };
      this.adSetData.language.forEach((lang, index) => {
        const code = langCodeMap[lang];
        if (code) {
          formData.append(`adset_langs[${index}]`, code);
        }
      });

      if (this.campaignObjective === "video_views") {
        formData.append(
          "adset_billing_event",
          this.adSetData.chargeType.toUpperCase()
        );
      }
      if (this.campaignObjective === "awareness") {
        formData.append("adset_billing_event", "IMPRESSION");
      }
      if (this.campaignObjective === "leads") {
        formData.append("adset_billing_event", "IMPRESSION");
      }

      const selectedNames =
        JSON.parse(localStorage.getItem("selectedNames")) || [];

      let locationIndex = 0;

      selectedNames.forEach((country) => {
        const cities = country.children || [];

        // أضف كل الدول بدل واحدة فقط
        if (country.country_code) {
          formData.append(
            `adset_location[${locationIndex}][snapchat_countries]`,
            country.country_code.toLowerCase()
          );
        }

        cities.forEach((city, i) => {
          if (city.region_code && !city.key) {
            formData.append(
              `adset_location[${locationIndex}][snapchat_regions][${i}]`,
              city.region_code
            );
          }
        });

        locationIndex++;
      });

      let tikTokIndex = 0;
      selectedNames.forEach((country) => {
        const tikTokCities = country.children?.filter(
          (city) => city.platform === "tiktok"
        );

        tikTokCities.forEach((city) => {
          if (city.region_code) {
            formData.append(
              `adset_location[${tikTokIndex}][tiktok_location_ids][${tikTokIndex}]`,
              city.region_code
            );
            tikTokIndex++;
          }
        });
      });

      let fbCityIndex = 0;
      selectedNames.forEach((country) => {
        const fbCities = country.children?.filter(
          (city) => city.platform === "facebook"
        );
        fbCities.forEach((city) => {
          if (city.key) {
            formData.append(
              `adset_location[${locationIndex}][facebook_cities][${fbCityIndex}][key]`,
              city.key
            );
            fbCityIndex++;
          }
        });
      });

      const selectedLatLngs =
        JSON.parse(localStorage.getItem("selectedLatLngs")) || [];

      selectedLatLngs.forEach((point, i) => {
        formData.append(
          `adset_circle_locations[0][circles][${i}][latitude]`,
          point.lat
        );
        formData.append(
          `adset_circle_locations[0][circles][${i}][longitude]`,
          point.lng
        );
        formData.append(
          `adset_circle_locations[0][circles][${i}][radius]`,
          point.radius
        );
        formData.append(
          "adset_circle_locations[0][circles][0][unit]",
          "KILOMETERS"
        );
      });

      const platformIndices = {
        snapchat: 0,
        facebook: 0,
        tiktok: 0,
      };

      this.campaignData.platforms.forEach((platform) => {
        const rawName = platform.name?.toLowerCase();
        const name = platformKeyMap[rawName];
        const budgetType = platform.budgetType?.toLowerCase();
        const amount = platform.budget;

        if (name && budgetType && amount && parseFloat(amount) > 0) {
          const key = `adset_${name}_${budgetType}_budget`;
          formData.append(key, amount);
        } else {
          console.warn(`Missing budget for ${name}`);
        }
      });

      // this.adSetData.interestsMap.forEach((interest) => {
      //   const index = platformIndices[interest.platform];

      //   switch (interest.platform) {
      //     case "facebook":
      //       formData.append(
      //         `adset_facebook_interests[${index}][id]`,
      //         interest.id
      //       );
      //       formData.append(
      //         `adset_facebook_interests[${index}][name]`,
      //         interest.label
      //       );
      //       break;
      //     case "snapchat":
      //       formData.append(`adset_snapchat_interests[${index}]`, interest.id);
      //       break;
      //     case "tiktok":
      //       formData.append(`adset_tiktok_interests[${index}]`, interest.id);
      //       break;
      //     default:
      //       console.warn("Unknown platform:", interest.platform);
      //       break;
      //   }

      //   platformIndices[interest.platform] += 1;
      // });

      this.appendInterestsToFormData(formData);
      formData.append("ad_name", this.adCreativeData.adName || "");
      formData.append("ad_primary_text", this.adCreativeData.headline || "");
      formData.append("ad_caption", this.adCreativeData.caption || "");
      if (this.campaignObjective === "leads") {
        formData.append("ad_attachments_type", "LEAD_GENERATION");
      } else {
        if (this.adCreativeData.showDestination) {
          formData.append("ad_attachments_type", "WEB_VIEW");

          formData.append(
            "ad_call_to_action_type",
            this.adCreativeData.cta
              ? this.adCreativeData.cta.toUpperCase().replace(/\s/g, "_")
              : null
          );
          formData.append("deep_link_uri", this.adCreativeData.deepLink);
          formData.append("ad_link_url", this.adCreativeData.websiteUrl || "");
        } else {
          formData.append("ad_attachments_type", "DEFAULT");
          formData.append("ad_link_url", null);
          formData.append("deep_link_uri", null);
          formData.append("ad_call_to_action_type", null);
        }
      }

      formData.append(
        "ad_status",
        this.adCreativeData.status ? "ACTIVE" : "PAUSED"
      );

      const selectedIdentities = JSON.parse(
        localStorage.getItem("selected_identity_accounts") || "{}"
      );

      if (selectedIdentities.facebook) {
        formData.append("ad_facebook_page_id", selectedIdentities.facebook.id);
      }

      if (selectedIdentities.snapchat) {
        formData.append("snapchat_profile_id", selectedIdentities.snapchat.id);
      }

      if (selectedIdentities.instagram) {
        formData.append(
          "ad_instagram_user_id",
          selectedIdentities.instagram.id
        );
      }

      if (selectedIdentities.tiktok) {
        formData.append("tiktok_profile_id", selectedIdentities.tiktok.id);
      }

      // if (this.adCreativeData.showDestination) {
      //   formData.append("ad_attachments_type", "WEB_VIEW");
      // } else {
      //   formData.append("ad_attachments_type", "DEFAULT");
      // }

      formData.append("snapchat_creative_id", this.snapchatcreativeu);
      formData.append("tiktok_creative_id", this.tiktokcreativeu);
      formData.append("tiktok_creative_url", this.tiktokcreativeurl);
      formData.append("facebook_creative_id", this.facebookcreativeu);

      if (this.adCreativeData.isImage && this.adCreativeData.music_id) {
        formData.append("tiktok_media_type", "image");
      } else {
        formData.append("tiktok_media_type", "video");
      }

      try {
        const response = await apiClient.post(
          "/super-ad/create/super-ad",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const { success = {}, failed = {} } = response.data.data;

        return {
          success,
          failed,
        };
      } catch (err) {
        console.error("❌ Error creating super ad:", err.response?.data || err);
        return {
          success: {},
          failed: {
            general:
              err.response?.data?.msg ||
              err.message ||
              "Unexpected error occurred",
          },
        };
      }
    },
    async tetrt() {
      // get profile id
      const accounts = JSON.parse(
        localStorage.getItem("superselected_accounts") || "{}"
      );

      const params = {
        facebook_account_id: accounts.facebook?.id || "",
        snapchat_account_id: accounts.snapchat?.id || "",
        tiktok_account_id: accounts.tiktok?.id || "",
      };

      const response = await apiClient.get("/super-ad/get/identities", {
        params,
      });

      console.log("✅ identities:", response.data);
    },
  },
});
